import axios from "axios";
import { paymentApiConfig, EXECUTE_RESULT } from "@/constant/config";
const queryString = require('query-string');
import moment from "moment";

const token = localStorage.getItem("token");
// const headers = {
//     "Access-Control-Allow-Origin": "*",
//     "Content-Type": "application/json",
// };

export default {



    //#region Promotion view
    promotionView: function (paymentMethod) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: paymentApiConfig.promotionViewUrl + '?paymentMethod=' + paymentMethod,
                //headers: headers,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    //#endregion

    ////#region Payment calculate
    paymentCalculate: function (getPointRequest) {
        let queryParams = queryString.stringify(getPointRequest);
        return new Promise(function (resolve, reject) {
            axios({
                method: "GET",
                url: `${paymentApiConfig.paymentCalculateUrl}?${queryParams}`,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
    //#endregion

    // Get list billing
    getListBilling: function (pagingItem) {
        return new Promise(function (resolve, reject) {
            let queryParams = queryString.stringify({
                "pageIndex": pagingItem.pageIndex,
                "pageSize": pagingItem.pageSize,
            });
            axios({
                method: "GET",
                url: `${paymentApiConfig.getListBillingUrl}?${queryParams}`,
                //headers: headers,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Get list transaction
    getListTransaction: function (pagingItem) {
        return new Promise(function (resolve, reject) {
            let queryParams = queryString.stringify({
                "page": pagingItem.page,
                "pageSize": pagingItem.pageSize,
            });
            axios({
                method: "GET",
                url: `${paymentApiConfig.getListTransactionUrl}?${queryParams}`,
                //headers: headers,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            resolve(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Create payment
    createPayment: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: paymentApiConfig.createPaymentUrl,
                timeout: 15000,
                //headers: headers,
                data: request,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },

    // Apply coupon
    applyCoupon: function (request) {
        return new Promise(function (resolve, reject) {
            axios({
                method: "POST",
                url: paymentApiConfig.applyCouponUrl,
                data: request,
                //headers: headers,
                withCredentials: true,
            })
                .then(res => {
                    try {
                        let resTemp = res.toJSON();
                        if (resTemp.name === 'Error') {
                            reject(resTemp);
                        }
                    } catch {
                        let response = res.data;
                        if (response.result === EXECUTE_RESULT.SUCCESS) {
                            resolve(response);
                        } else {
                            reject(response);
                        }
                    }
                })
                .catch(error => {
                    reject(error);
                });
        })
    },
}